<template>
    <div>
        <b-card no-body class="p-0">
                <b-tabs card class="p-0 investimentos" justified>
                    <b-tab :title="aba.titulo" v-for="aba in abas" :key="aba.titulo" class="p-0">
                        <accordion
                            v-for="investimento,i in aba.dados" :key="i"
                            :id="`sub_investimento${i}_${aba.endpoint}`"
                            :title="investimento.recebedora"
                            sub
                            :accordion="`sub_investimento${i}_${aba.endpoint}`"
                            visible
                        >
                            <template #append-title>
                                <b-badge class="ml-2" :variant="investimento.salvo ? 'success' : 'danger'">
                                    {{ investimento.salvo ? "Aprovado" : "Não aprovado" }}
                                </b-badge>
                            </template>
                            <div class="row pt-3">
                                <div class="col-12 text-red-500 px-3" v-for="debito,i in investimento.debitos" :key="`debito${i}`">
                                    <span>
                                        {{debito.descricao}} - 
                                    </span>
                                    <span class="float-right">
                                        {{debito.valor}}
                                    </span>
                                </div>

                                
                                
                                <div class="col-12"><hr></div>


                                <div class="col-12 col-md-4 text-center">
                                    <b-badge>Total previsto na proposta</b-badge>
                                    <div>{{investimento.totalPrevistoProposta}}</div>
                                </div>
                                <div class="col-12 col-md-4 text-center">
                                    <b-badge>Total realizado</b-badge>
                                    <div>{{investimento.totalPrevisto}}</div>
                                </div>
                                <div class="col-12 col-md-4 ">
                                    <b-badge>Valor reconhecido auditoria</b-badge>                                    
                                    <input-money class="pr-2" no-label v-model="investimento.valorAlocado" label="Valor à investir" :ref="`${investimento.key}-valor`"/>
                                </div>
                                
                                
                            </div>
                            <hr>
                            <div class="row p-3">
                                <div class="col-12 col-md-3 mb-2">
                                    <b-badge :variant="calcularDesvio(investimento).porcentagem > 0 ? 'danger' : 'primary'">Desvio</b-badge>
                                    <div :class="`text-${calcularDesvio(investimento).porcentagem > 0 ? 'red' : 'black'}-500`">{{calcularDesvio(investimento).desvio}}/ <span class="h6">{{calcularDesvio(investimento).porcentagem}}%</span></div>
                                </div>
                                    <input-textarea class="col-12" :readonly="!calcularDesvio(investimento).liberaJustificativa" label="Justificativa"  v-model="investimento.justificativa" :required="calcularDesvio(investimento).liberaJustificativa" :ref="`${investimento.key}-justificativa`" />
                                <div class="col-12">
                                    <b-button variant="success" v-if="permissao.u && projetoEditavel" @click="salvar(investimento, aba.endpoint)">
                                        <i class="fa-solid fa-check mr-2"></i>
                                        Aprovar distribuição
                                    </b-button>
                                </div>
                            </div>
                        </accordion>
                    </b-tab>
                </b-tabs>
        </b-card>
    </div>
</template>
<script>
import ProjetoService from "@/common/services/projeto/projeto.service";
import InputMoney from "@/components/inputs/InputMoney.vue";
import InputTextarea from "@/components/inputs/InputTextarea.vue";
import Accordion from "@/components/card/Accordion"

import { START_LOADING, STOP_LOADING } from "@/store/Store";
import helpers from "@/common/utils/helpers";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";
import { FormMixin } from "@/common/mixins/FormMixin";
import cloneDeep from "lodash/cloneDeep";
export default {
    mixins: [AlertasMixin,FormMixin],
    props :{
        projetoId : {
            required : true,
        },
        nomeIdProjeto : {
            required : true,
        },
        endpoint : {
            required : true,
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    components: {
        InputMoney,
        InputTextarea,
        Accordion
    },
    data : () =>({
        buscando : 0,
        abas : [
            { titulo : "RH - Recursos humanos", rubrica : 'recurso-humano', endpoint : "investimento-recurso-humano", dados : [], totais : {} },
            { titulo : "ST - Serviço terceiro", rubrica : 'servico-terceiro', endpoint : "investimento-servico-terceiro", dados : [], totais : {} },
            { titulo : "MC - Material de consumo", rubrica : 'material-consumo', endpoint : "investimento-material-consumo", dados : [], totais : {} },
            { titulo : "MPE - Materiais permanentes e equipamentos", rubrica : 'material-permanente', endpoint : "investimento-material-permanente", dados : [], totais : {} },
            { titulo : "VD - Viagens e diárias", rubrica : 'viagem-diaria', endpoint : "investimento-viagem-diaria", dados : [], totais : {} },
            { titulo : "OU - Outros", rubrica : 'outro-recurso', endpoint : "investimento-outro-recurso", dados : [], totais : {} },
        ]
    }),
    methods : {
        formatarValor : function(valor){
            return helpers.formatarValor(valor);
        },
        buscarDebitos : function(investimento, rubrica){
            

            let id = null;
            let nomeId = null;
            if(investimento.projetoId){
                ProjetoService.setEndpoint('Projeto');
                id = investimento.projetoId;
                nomeId = 'projetoId';
            }else if(investimento.projetoEmpresaExecutoraCriadoraId){
                ProjetoService.setEndpoint('ProjetoEmpresaExecutoraCriadora');
                id = investimento.projetoEmpresaExecutoraCriadoraId;
                nomeId = 'ProjetoExecutoraCriadoraId';
            }else if(investimento.projetoEmpresaExecutoraId){
                ProjetoService.setEndpoint('ProjetoEmpresaExecutora');
                id = investimento.projetoEmpresaExecutoraId;
                nomeId = 'ProjetoExecutoraId';
            }else if(investimento.projetoEmpresaCooperadaId){
                ProjetoService.setEndpoint('ProjetoEmpresaCooperada');
                id = investimento.projetoEmpresaCooperadaId;
                nomeId = 'ProjetoCooperadaId';
            }

            if(rubrica == 'recurso-humano'){
                ProjetoService.listarRH(id, nomeId).then(res => {
                    this.abas.find(aba => aba.rubrica == rubrica).dados.find(dados => dados.key == investimento.key).debitos = res.data.data.equipe.alocacaoHorasIndividuais.map(el => {
                        let totalHoras = el.horasSazonais.reduce((total,hora) => {return total += hora.horas},0)
                        let valorTotal = el.valorHora * totalHoras;
                        return {
                            descricao : `${el.pessoa.nome} (${helpers.getEnum(el.funcao) ? helpers.getEnum(el.funcao).text : 'Sem função'})`,
                            valor : helpers.formatarValor(valorTotal)
                        }
                    })    
                })
            }else{
                ProjetoService.listarGenerico(rubrica, id, nomeId).then(res => {
                    
                    this.abas.find(aba => aba.rubrica == rubrica).dados.find(dados => dados.key == investimento.key).debitos = res.data.data.itens.map(el => {
                        return {
                            descricao : `${helpers.getEnum(el.tipoDocumento).text} (N° Doc: ${el.numeroDocumento})`,
                            valor : helpers.formatarValor(el.valorIndividual * el.quantidade)
                        }
                    })
    
                })
            }
                
            ProjetoService.setEndpoint(this.endpoint);
        
        },
        buscarInvestimentos : function(endpoint){
            this.$store.dispatch(START_LOADING);
            this.buscando = this.abas.filter(el => endpoint ? el.endpoint == endpoint : true).length;
            this.abas.filter(el => endpoint ? el.endpoint == endpoint : true).forEach(element => {
                ProjetoService.buscarInvestimentos(this.projetoId, element.endpoint, this.nomeIdProjeto).then(response => {
                    let res = response.data.data;

                    element.totais = {
                        totalPrevistoProposta : helpers.formatarValor(res.reduce((total, el) => total + el.totalPrevistoProposta ? el.totalPrevistoProposta : 0, 0)),
                        totalPrevisto : helpers.formatarValor(res.reduce((total, el) => total + el.totalPrevisto ? el.totalPrevisto : 0, 0)),
                        valorAlocado : helpers.formatarValor(res.reduce((total, el) => total + el.valorAlocado ? el.valorAlocado : 0, 0)),
                    };

                    
                    element.dados = res.map((el,i) => {
                        el.key = `${new Date().getTime()}_${i}`
                        el.debitos = [];
                        this.buscarDebitos(el, element.rubrica);
                    
                        
                        

                        el.restante = helpers.formatarValor(el.valorRestante || (el.totalPrevisto - el.valorAlocado));
                        el.valorAlocado = helpers.formatarValor(el.valorAlocado);
                        el.totalPrevistoProposta = el.totalPrevistoProposta ? helpers.formatarValor(el.totalPrevistoProposta) : '-';
                        el.totalPrevisto = helpers.formatarValor(el.totalPrevisto ? el.totalPrevisto : 0);
                        el.justificativa = el.justificativa || '';


                        return el;
                    });

                }).finally(() => {
                    this.buscando--;
                    if(this.buscando == 0){
                        this.$store.dispatch(STOP_LOADING);
                    }
                });                
            });
        },
        salvar : function(item, endpoint){
            let form = cloneDeep(item);
            this.confirmar("Deseja salvar investimento?").then(confirmado => {
                if(!confirmado)
                    return false;

                if(!this.validateState(`${item.key}-`))
                    return false;
                
                if(item.liberaJustificativa && !item.justificativa){
                    this.alertaErro("Preencha a justificativa");
                    return false;
                }

                form.valorAlocado = helpers.removerValor(form.valorAlocado);

                this.$store.dispatch(START_LOADING);
                ProjetoService.salvarInvestimento(form, endpoint).then(() => {
                    this.alertaSucesso("Investimento salvo com sucesso!");
                    this.buscarInvestimentos(endpoint);
                }).catch(err => {
                    if(err.response.status == 400){
                        this.alertaErro(err.response.data.errors);
                    }else{
                        this.alertaErro("Ocorreu um erro ao salvar o investimento!");
                    }                        
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            });
        },
        montar : function(){
            this.buscarInvestimentos();
        },
        calcularDesvio(item) {
            const valorAlocado = Number(helpers.removerValor(item.totalPrevisto)) || 0;
            const totalPrevistoProposta =
                Number(helpers.removerValor(item.totalPrevistoProposta || 0)) || 0;

            const desvioNum = valorAlocado - totalPrevistoProposta;

            let porcentagemNum;
            if (totalPrevistoProposta === 0) {
                porcentagemNum = desvioNum > 0 ? 100 : 0;
            } else {
                porcentagemNum = (desvioNum * 100) / totalPrevistoProposta;
                if (!isFinite(porcentagemNum) || isNaN(porcentagemNum)) porcentagemNum = 0;
                if (desvioNum < 0) porcentagemNum = 0;
            }

            return {
                desvio: helpers.formatarValor(desvioNum),
                porcentagem: Number(porcentagemNum.toFixed(2)),
                liberaJustificativa: desvioNum > 0,
                justificativa: item.justificativa || ''
            };
        },
    },
    mounted(){
        //this.buscarInvestimentos();
    },
    computed : {
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosPdInvestimentos');
        },
    }
}
</script>
<style>
    .investimentos .card-header {
        background: #f3f2f2; border-bottom: 1px solid #e5e5e5;
    }

    .investimentos .card-header-tabs{
        align-items: end;
    }
</style>